import { ArticleInfo } from '@wix/ambassador-kb-generate-answer-v1-generate-answer-request/types';
import { EditorType } from '@wix/ambassador-meta-site-search-web/types';

import { ANSWER_GENERATION_TIMEOUT } from '../../../constants';
import { logger } from '../../util/logger';
import { fedopsLogger, renderModel } from '../../util/renderModel';
import { HttpClientFactory } from '../httpClient';

const { clientTopology } = renderModel.get();

export type GenerateAnswerResult = {
  query: string;
  term?: string;
  answer: string | null;
  usedArticles: string[];
  usedArticlesInfo: ArticleInfo[];
  prohibited: boolean;
};

export const generateAnswer = async (
  query: string,
  httpClient: HttpClientFactory,
  editorType?: EditorType,
): Promise<GenerateAnswerResult> => {
  try {
    fedopsLogger.interactionStarted('generate-answer-ai');

    const response = await httpClient.getInstance().post<GenerateAnswerResult>(
      clientTopology.generateAnswerUrl,
      {
        query,
        editorType,
      },
      { timeout: ANSWER_GENERATION_TIMEOUT },
    );

    fedopsLogger.interactionEnded('generate-answer-ai');

    return response.data;
  } catch (error) {
    logger.error({
      message: `fail to generate AI answer by query: ${query}`,
      error,
    });
    throw error;
  }
};
